import { createShopifyHarnessClient, type ShopifyHarnessClient } from "@shopify-harness/sdk";

import { env } from "./env";
import { createStubApi } from "./stub-api";

export type AppApi = Pick<ShopifyHarnessClient, "contacts" | "health" | "milestones" | "personas">;

export interface AppServices {
  api: AppApi;
  apiBaseUrl: string;
}

export function createAppServices(baseUrl = env.VITE_API_BASE_URL): AppServices {
  return {
    // stub モードは Worker 未起動で UI を確認するための構成。切替はここだけで閉じる。
    api: env.VITE_API_MODE === "stub" ? createStubApi() : createShopifyHarnessClient({ baseUrl }),
    apiBaseUrl: baseUrl
  };
}
